import Vue from 'vue'
import Button from './Buttons/ButtonCadu.vue'
import TextField from './TextField/TextField.vue'
import LeftNavBar from './NavBars/LeftNavBar'
import HeaderNavBar from './NavBars/HeaderNavBar'
import BottomNavBar from './NavBars/BottomNavBar'
import Switch from './Switch/Switch'
import CheckBox from './CheckBox/CheckBox'
import Modal from './Modal/Modal'
import Icon from './Icon'
import AutoComplete from './AutoComplete/AutoComplete'
import AutoCompleteCheckbox from './AutoComplete/AutoCompleteCheckBox'
import Spinner from './Loading/Spinner'
import Tabs from './Tabs/Tabs'
import ButtonsGroup from './ButtonsGroup/ButtonsGroup'
import PendenciaModal from './PendenciaModal/PendenciaModal'
import TextArea from './TextArea/TextArea'
import Table from './Table/Table'
import ButtonRounded from './ButtonRounded/ButtonRounded'
import BlockButtonRounded from './BlockButtonRounded/BlockButtonRounded'
import SucessoModal from './ModalUtil/SucessoModal'
import ExcluirModal from './ModalUtil/ExcluirModal'
import Filtro from './Filtro/Filtro'
import ErrorModal from './ErrorModal/ErrorModal'
import OverlayLoading from './OverlayLoading/OverlayLoading'
import ComponentLoading from './ComponentLoading/ComponentLoading'
import VersaoModal from '../MinhaUnimed/Shared/VersaoModal'
//import Tooltip from './Tooltip/Tooltip'
import TooltipHelp from './Tooltip/TooltipHelp'
import DatePicker from './DatePicker/DatePicker'
import Card from './Card/Card'
import ModalCancelar from './ModalCancelar/ModalCancelar'
import ModalAnexo from './ModalAnexo/ModalAnexo'
import SearchBar from './SearchBar/SearchBar'
import Recibo from '../MinhaUnimed/Historico/Shared/ModalHistorico'
import CheckList from './CheckList/CheckList'
import ButtonSearch from './ButtonSearch/ButtonSearch'
import HierarquiaCard from './HierarquiaCard/HierarquiaCard'
import TooltipUnimed from './TooltipBase/TooltipUnimed'
import TooltipBase from './TooltipBase/TooltipBase'

Vue.component('checkList-cadu', CheckList)
Vue.component('recibo-cadu', Recibo)
Vue.component('filtro-cadu', Filtro)
Vue.component('buttons-group', ButtonsGroup)
Vue.component('spinner-cadu', Spinner)
Vue.component('autocompletecheck-cadu', AutoCompleteCheckbox)
Vue.component('autocomplete-cadu', AutoComplete)
Vue.component('button-cadu', Button)
Vue.component('input-cadu', TextField)
Vue.component('switch-cadu', Switch)
Vue.component('checkbox-cadu', CheckBox)
Vue.component('modal-cadu', Modal)
Vue.component('left-nav', LeftNavBar)
Vue.component('header-nav', HeaderNavBar)
Vue.component('bottom-nav', BottomNavBar)
Vue.component('icon', Icon)
Vue.component('tabs-cadu', Tabs)
Vue.component('pendencia-modal', PendenciaModal)
Vue.component('textarea-cadu', TextArea)
Vue.component('table-cadu', Table)
Vue.component('button-rounded', ButtonRounded)
Vue.component('block-button-rounded', BlockButtonRounded)
Vue.component('SucessoModal', SucessoModal)
Vue.component('ExcluirModal', ExcluirModal)
Vue.component('error-modal', ErrorModal)
Vue.component('overlay-loading', OverlayLoading)
Vue.component('component-loading', ComponentLoading)
Vue.component('versao-modal', VersaoModal)
//Vue.component('tooltip-cadu', Tooltip)
Vue.component('tooltip-help', TooltipHelp)
Vue.component('datepicker-cadu', DatePicker)
Vue.component('card-cadu', Card)
Vue.component('modal-cancelar', ModalCancelar)
Vue.component('modal-anexo', ModalAnexo)
Vue.component('search-bar', SearchBar)
Vue.component('button-search', ButtonSearch)
Vue.component('hierarquia-card', HierarquiaCard)
Vue.component('tooltip-unimed', TooltipUnimed)
Vue.component('tooltip-base', TooltipBase)
